import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import ListChannels from "./ListChannels";

// import ArtifactContextLayout from "./ArtifactContextLayout";

import { ChannelDetail } from "./ChannelDetail";
import ChannelHistory from "./ChannelHistory";
import ChannelModerationLayout from "./ChannelModerationLayout";
import { useNavigationBar } from "../../context/NavigationContext";
import { UpdateListProvider } from "./UpdateListContext";
import ChannelReports from "./channelReports";

const ChannelModeration = () => {
  const location = useLocation();
  const { backgroundLocation } = useNavigationBar();
  //const state = location.state as { backgroundLocation?: Location };
  const oldLocation = backgroundLocation?.pathname.includes("dashboard/channelModeration") ? backgroundLocation : location;

  return (
    <>
      {/* <Routes location={background || location}> */}
      <UpdateListProvider>
        <Routes location={oldLocation}>
          <Route path="/list" element={<ListChannels />} />
          {/* <Route path="/list" element={<ListChannels />}>
          <Route path=":id" element={<ChannelDetail />} />
          <Route path="/history" element={<ChannelHistory />} />
        </Route> */}
          <Route element={<ChannelModerationLayout />}>
            <Route path="/list/:id" element={<ChannelDetail />} />
            <Route path="/list/:id/history" element={<ChannelHistory />} />
            <Route path="/list/:id/reports" element={<ChannelReports />} />
          </Route>
          <Route element={<ChannelModerationLayout isEditReview={true} />}>
            <Route path="/list/:id/channelEditsDetail" element={<ChannelDetail />} />
          </Route>
          <Route path="/" element={<Navigate replace to="./list" />} />
        </Routes>
        {backgroundLocation && (
          <Routes>
            <Route element={<ChannelModerationLayout />}>
              <Route path="/list/:id" element={<ChannelDetail />} />
              {/* <Route path="history" element={<ChannelHistory />} />
            </Route> */}
              <Route path="/list/:id/history" element={<ChannelHistory />} />
              <Route path="/list/:id/reports" element={<ChannelReports />} />
            </Route>
            <Route element={<ChannelModerationLayout isEditReview={true} />}>
              <Route path="/list/:id/channelEditsDetail" element={<ChannelDetail />} />
            </Route>
          </Routes>
        )}
      </UpdateListProvider>
    </>
  );
};

export default ChannelModeration;
